<template>
  <a-spin :spinning="confirmLoading">
  <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <!--label="单价"-->
            <a-form-item :label="$t('label.unitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['unitPrice', validatorRules.unitPrice]" :placeholder="$t('label.pleaseEnterTheUnitPrice')" style="width: 84%" @change="marginChange"/> {{ $t('label.rMBBird') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="余额"-->
            <a-form-item :label="$t('label.balance')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :disabled="true" v-decorator="['balance']" :placeholder="$t('label.pleaseEnterTheBalance')" style="width: 84%"/> {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="金额"-->
            <a-form-item :label="$t('label.amount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :disabled="true" v-decorator="['amount']" :placeholder="$t('label.pleaseEnterTheAmount')" style="width: 84%"/> {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item v-has="'conCode'" :label="$t('label.contractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['conCode']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </j-form-container>
  <a-tabs v-model="activeKey" @change="handleChangeTabs">
    <a-tab-pane :tab="$t('tabName.marginRecord')" :key="refKeys[0]" :forceRender="true">
      <j-editable-table
        :ref="refKeys[0]"
        :tableName="tableName"
        :loading="efsStlSettleApplyTable.loading"
        :columns="efsStlSettleApplyTable.columns"
        :dataSource="efsStlSettleApplyTable.dataSource"
        :maxHeight="300"
        :disabled="formDisabled"
        :rowNumber="true"
        :rowSelection="true"
        :actionButton="false"/>
    </a-tab-pane>
  </a-tabs>
  </a-spin>
</template>
<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'

  export default {
    name: 'EfsStdMarginForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      // 当前table对应的数据表名
      tableName: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        mainTable: this.tableName,
        subTable: [''],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        validatorRules: {
          unitPrice: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheUnitPrice')},
            ]
          },
        },
        refKeys: ['efsStlSettleApply',  ],
        tableKeys:['efsStlSettleApply', ],
        activeKey: 'efsStlSettleApply',
        // efs_stl_settle_apply
        efsStlSettleApplyTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              //title: '业务类型',
              title: this.$t('tableHeader.businessType'),
              key: 'subType',
              type: FormTypes.select,
              dictCode:"deposit_type",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              //title: '金额',
              title: this.$t('tableHeader.amount'),
              key: 'applyAmount',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              //title: '记账日期',
              title: this.$t('tableHeader.bookkeepingDate'),
              key: 'applyTime',
              type: FormTypes.date,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
          ]
        },
        url: {
          efsStlSettleApply: {
            list: '/newContractManage/efsMdContract/queryEfsStlSettleApplyByMainId'
          },
        },
          planBreedQty: ''
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      }
    },
      mounted() {
        this.$bus.$on('planBreedQtyChange', e => {
            this.planBreedQty = e
            let unitPrice = this.form.getFieldsValue(['unitPrice']).unitPrice
            if (e && unitPrice) {
                this.model.amount = (e * 1) * (unitPrice * 1)
            } else {
                this.model.amount = 0
            }
            this.form.setFieldsValue(pick(this.model,'amount'))
        })
      },
    methods:{
      initFormData(url,id){
        this.clearFormData()
        if(!id){
          this.edit({})
        }else{
          getAction(url,{id:id}).then(res=>{
            if(res.success){
              let records = res.result
              if(records && records.length>0){
                this.edit(records[0])
              }
            }
          })
        }
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },

      edit(record){
        this.model = Object.assign({}, record)
        console.log("EfsStdMarginForm-edit",this.model);
        let fieldval = pick(this.model,'conCode','unitPrice','balance','amount')
        if (this.model.id) {
          let params = { conCode: this.model.conCode }
          this.requestSubTableData(this.url.efsStlSettleApply.list, params, this.efsStlSettleApplyTable)
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
      },
      getFormData(){
        let formdata_arr = []
        this.form.validateFields((err, values) => {
          if (!err) {
            let formdata = Object.assign(this.model, values)
            let isNullObj = true
            Object.keys(formdata).forEach(key=>{
              if(formdata[key]){
                isNullObj = false
              }
            })
            if(!isNullObj){
              formdata_arr.push(formdata)
            }
          }else{
            this.$emit("validateError",this.$t('tip.marginFormCheckFailed'));
          }
        })
        console.log("efs_std_margin表单数据集",formdata_arr);
        return formdata_arr;
      },
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'conCode','unitPrice','balance','amount'))
      },
      clearFormData(){
        this.form.resetFields()
        this.model={}
      },
        marginChange(e){
          if (e && this.planBreedQty) {
              this.model.amount = (e * 1) * (this.planBreedQty * 1)
          } else {
              this.model.amount = 0
          }
          this.form.setFieldsValue(pick(this.model,'amount'))
        }
    }
  }
</script>
